export type RoundShareBreakdown = {
  roundId: string;
  roundName: string;
  shares: number;
  equityShares: number;
  prefShares: number;
  debentures: number;
  warrants: number;
  notes: number;
  options: number;
};

export type ShareValues = Omit<RoundShareBreakdown, "roundId" | "roundName">;

type HoldingWithRoundShares = Partial<ShareValues> & {
  sharesByRound?: RoundShareBreakdown[];
};

const emptyShareValues = (): ShareValues => ({
  shares: 0,
  equityShares: 0,
  prefShares: 0,
  debentures: 0,
  warrants: 0,
  notes: 0,
  options: 0,
});

export function getSelectedRoundNames(filterModel: any): string[] {
  return Array.isArray(filterModel?.rounds?.values)
    ? filterModel.rounds.values
    : [];
}

export function getDisplayedRounds<T extends { roundName: string }>(
  rounds: T[] | undefined,
  selectedRoundNames: string[]
): T[] {
  if (selectedRoundNames.length === 0) return rounds || [];
  const selectedRounds = new Set(selectedRoundNames);
  return (rounds || []).filter((round) => selectedRounds.has(round.roundName));
}

export function projectSharesForRounds(
  holding: HoldingWithRoundShares,
  selectedRoundNames: string[]
): ShareValues {
  if (selectedRoundNames.length === 0) {
    return {
      shares: holding.shares || 0,
      equityShares: holding.equityShares || 0,
      prefShares: holding.prefShares || 0,
      debentures: holding.debentures || 0,
      warrants: holding.warrants || 0,
      notes: holding.notes || 0,
      options: holding.options || 0,
    };
  }

  const selectedRounds = new Set(selectedRoundNames);
  return (holding.sharesByRound || [])
    .filter((round) => selectedRounds.has(round.roundName))
    .reduce((total, round) => {
      total.shares += round.shares || 0;
      total.equityShares += round.equityShares || 0;
      total.prefShares += round.prefShares || 0;
      total.debentures += round.debentures || 0;
      total.warrants += round.warrants || 0;
      total.notes += round.notes || 0;
      total.options += round.options || 0;
      return total;
    }, emptyShareValues());
}
